import { render } from "./SolicitationList.vue?vue&type=template&id=505f949b&scoped=true"
import script from "./SolicitationList.vue?vue&type=script&lang=js"
export * from "./SolicitationList.vue?vue&type=script&lang=js"

import "./SolicitationList.vue?vue&type=style&index=0&id=505f949b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505f949b"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
